export const SCENARIO_CARMAKER_VARIATION_LIST_DATA = "SCENARIO_CARMAKER_VARIATION_LIST_DATA";
export const SCENARIO_CARMAKER_VERSION_LIST_DATA = "SCENARIO_CARMAKER_VERSION_LIST_DATA"
